import React, { useState, useEffect } from "react";
import { Grid, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import CustomTypography from "../../globalStyles/fonts";
import { currencyTypes } from "../../utils/services/currencyTypes";
import { statusTypes } from "../../utils/services/statusTypes";
import AutocompleteWithPagination from "../../components/autocomplete-with-pagination";
import ClientAutocomplete from "../../components/clientAutocomplete";

const ProductMeta = ({
  productDetails,
  setProductDetails,
  supplierService,
  buildQuery,
  setVendor,
  selectedClient,
  formErrors,
  setFormErrors,
}) => {
  const [localVendor, setLocalVendor] = useState(null);

  useEffect(() => {
    // Set vendor only if it's not already set
    if (!localVendor && productDetails?.vendor) {
      setLocalVendor(productDetails.vendor);
      setVendor(productDetails.vendor); // sync to parent
    }
  }, [productDetails?.vendor, localVendor]);

  useEffect(() => {
    setVendor(localVendor);
  }, [localVendor, setVendor]);

  // useEffect(() => {
  //   setLocalVendor(null);
  // }, [selectedClient]);
  useEffect(() => {
    // Reset local vendor when client changes
    setLocalVendor(null);
    setProductDetails((prev) => ({ ...prev, vendor: null }));
  }, [selectedClient?._id]);

  return (
    <>
      <Grid item xs={6} sm={4}>
        <CustomTypography
          style={{ textAlign: "left", fontWeight: 500 }}
          fontSize={15}
        >
          Currency <span style={{ color: "red" }}>*</span>
        </CustomTypography>
        <Autocomplete
          value={productDetails.currency || null}
          disableClearable={!productDetails.currency}
          onChange={(e, newValue) => {
            setProductDetails({ ...productDetails, currency: newValue });
            setFormErrors({ ...formErrors, currency: undefined });
          }}
          size="small"
          options={currencyTypes}
          isOptionEqualToValue={(option, value) =>
            option === value || (!value && !option)
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              margin="dense"
              style={{ backgroundColor: "var(--bg-paper)" }}
              error={!!formErrors.currency}
              helperText={formErrors.currency}
            />
          )}
        />
      </Grid>

      <Grid item xs={6} sm={4}>
        <CustomTypography
          style={{ textAlign: "left", fontWeight: 500 }}
          fontSize={15}
        >
          Status <span style={{ color: "red" }}>*</span>
        </CustomTypography>
        <Autocomplete
          disableClearable={!productDetails.status}
          value={productDetails.status || null}
          onChange={(e, newValue) => {
            setProductDetails({ ...productDetails, status: newValue });
            setFormErrors({ ...formErrors, status: undefined });
          }}
          size="small"
          options={statusTypes}
          isOptionEqualToValue={(option, value) =>
            option === value || (!value && !option)
          }
          renderInput={(params) => (
            <TextField
              {...params}
              margin="dense"
              variant="outlined"
              style={{ backgroundColor: "var(--bg-paper)" }}
              error={!!formErrors.status}
              helperText={formErrors.status}
            />
          )}
        />
      </Grid>

      <Grid item xs={6} sm={4}>
        <CustomTypography
          style={{ textAlign: "left", fontWeight: 500 }}
          fontSize={15}
        >
          Supplier <span style={{ color: "red" }}>*</span>
        </CustomTypography>
        <AutocompleteWithPagination
          key={selectedClient?._id || "no-client"}
          disabled={!localStorage.getItem("client_id") && !selectedClient?._id}
          backgroundColor="var(--bg-paper)"
          customLabel="Supplier"
          selectedItem={localVendor}
          selectedClient={selectedClient}
          onDataChange={(supplier) => {
            setLocalVendor(supplier || null); //  handles null cleanly
            setProductDetails((prev) => ({
              ...prev,
              vendor: supplier || null,
            })); // keeps productDetails in sync
            setFormErrors({ ...formErrors, vendor: undefined });
          }}
          width="100%"
          optionKey="name"
          apiEndPoint={(limit, skip, search, client) => {
            const query = buildQuery({ limit: limit, skip: skip });
            return supplierService.fetch(search, client, query);
          }}
          errorMessage={formErrors.vendor ? formErrors.vendor : ""}
        />
      </Grid>
    </>
  );
};

export default ProductMeta;
